import request from "../../request.js"
import CONFIG from "../../../utils/config.js"
import URL from "../../url/story/index.js"

class Story{
    //获取栏目稿件列表
    static getStoryList({column}){
        return request.get({
            url: `columns/${column}/stories.json`
        })
    }
    //获取栏目聚合稿件列表
    static getUniqueStoryList({column,size=6}){
        return request.get({
            url: `columns/${column}/unique/repthePerson/stories.json?size=${size}`
        })
    }
    static getStoryAppList({column}){
        return request.get({
            url: `columns/${column}/tkww/app/stories.json`
        })
    }
    static getStoryListByPage({page=0,columnId}){
        return request.get({
            url: `columns/${columnId}/tkww/app/stories/more_${page}.json`
        })
    }
    //获取标签稿件列表
    static getStoryListByTag({tag,columnId="all",size=300,typeNot="INNERLINK",page="",excludeColumnId="",typeMust="",columns="columns",order=""}){
        let url = `channels/tkww/${columns}/${columnId}/tags/${tag}/stories.json`
        if(size!==""){
            url += `?size=${size}`
        }
        if(page!==""){
            url += `&page=${page}`
        }
        if(excludeColumnId!==""){
            url += `&excludeColumnId=${excludeColumnId}`
        }
        if(typeNot!==""){
            url += `&typeNot=${typeNot}`
        }
        if(typeMust!==""){
            url += `&typeMust=${typeMust}`
        }
        if(order!==""){
            url += `&order=${order}`
        }
        return request.get({
            url
        })
    }
    //获取管道欄目稿件列表
    static getStoryListByColumn({channel="tkww",column="all",size=1000}){
        let url = `channels/${channel}/columns/${column}/${channel}/stories.json?size=${size}`
        return request.get({
            url
        })
    }
    //热榜
    static getHotList({channelId,hours,columnUuid="",includeInnerlink=false,baseUrl=""}){
        let url = `/channels/${channelId}/hotlist/hours/${hours}/stories.json`
        /*if(columnUuid!=="")url+=`?columnId=${columnUuid}`
        if(includeInnerlink!==false)url+=`?includeInnerlink=${includeInnerlink}`*/
        let params = []
        if(columnUuid!==""){
            params.push({
                key:"columnId",
                value:columnUuid
            })
        }
        if(includeInnerlink!==false){
            params.push({
                key:"includeInnerlink",
                value:includeInnerlink
            })
        }
        for(let i = 0;i<params.length;i++){
            if(i===0){
                url += "?"
            }else{
                url += "&"
            }
            url += `${params[i].key}=${params[i].value}`
        }
        return request.get({
            url,
            /*config: {
                baseURL:baseUrl===""?CONFIG.BASE_HOST_NAME:baseUrl
            }*/
        })
    }
    //文匯報热榜
    static getWwpHotList({channelId,hours,columnUuid="",includeInnerlink=false}){
        let url = `/channels/${channelId}/hotlist/hours/${hours}/stories.json`
        /*if(columnUuid!=="")url+=`?columnId=${columnUuid}`
        if(includeInnerlink!==false)url+=`?includeInnerlink=${includeInnerlink}`*/
        let params = []
        if(columnUuid!==""){
            params.push({
                key:"columnId",
                value:columnUuid
            })
        }
        if(includeInnerlink!==false){
            params.push({
                key:"includeInnerlink",
                value:includeInnerlink
            })
        }
        for(let i = 0;i<params.length;i++){
            if(i===0){
                url += "?"
            }else{
                url += "&"
            }
            url += `${params[i].key}=${params[i].value}`
        }
        return request.get({
            url,
            config: {
                baseURL:CONFIG.BASE_WWP_URL
            }
        })
    }
    //获取稿件瀏覽次數
    static getStoryBrownTime({channelId='tkww',articleId}){
        let url = `${URL.BROWN_TIME}?channelId=${channelId}&articleId=${articleId}`
        return request.get({
            url
        })
    }
}
export default Story